import { render, staticRenderFns } from "./SelectedDinamicField.vue?vue&type=template&id=956706c2"
import script from "./SelectedDinamicField.vue?vue&type=script&lang=js"
export * from "./SelectedDinamicField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports